<template>
    <div class="cal-grid" :style="{ '--cal-cols': columnTemplate }">
        <div class="cal-grid__weekdays" aria-hidden="true">
            <div v-for="label in WEEKDAY_LABELS" :key="label" class="cal-grid__weekday">
                {{ label }}
            </div>
        </div>
        <div class="cal-grid__days" role="grid" aria-label="Календарь матчей">
            <CalendarDayCell
                v-for="(day, index) in cells"
                :key="`${year}-${month}-${index}`"
                :day="day"
                @select-game="$emit('select-game', $event)"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import CalendarDayCell from './CalendarDayCell.vue';
import { WEEKDAY_LABELS, buildCalendarCells, weekdayIndex } from '@/utils/calendarMonth';

const props = defineProps({
    year: { type: Number, required: true },
    month: { type: Number, required: true },
    gamesByDate: { type: Object, default: () => ({}) },
});

defineEmits(['select-game']);

const EQUAL_COLUMNS = 'repeat(7, minmax(0, 1fr))';
const COL_WIDE = 'minmax(0, 1.5fr)';
const COL_QUIET = 'minmax(0, 0.65fr)';

const cells = computed(() => buildCalendarCells(props.year, props.month, props.gamesByDate));

const columnTemplate = computed(() => {
    const flags = [false, false, false, false, false, false, false];
    let anyGames = false;

    for (const cell of cells.value) {
        if (!cell.dateKey || !cell.games.length) {
            continue;
        }

        anyGames = true;
        flags[weekdayIndex(cell.dateKey)] = true;
    }

    if (!anyGames) {
        return EQUAL_COLUMNS;
    }

    return flags.map((hasGames) => (hasGames ? COL_WIDE : COL_QUIET)).join(' ');
});
</script>

<style lang="scss" scoped>
@import '../../../../scss/tokens';

.cal-grid {
    --cal-cols: repeat(7, minmax(0, 1fr));

    background: rgba(255, 255, 255, 0.55);
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: $radius-md;
    overflow: hidden;
}

.cal-grid__weekdays,
.cal-grid__days {
    display: grid;
    grid-template-columns: var(--cal-cols);
}

.cal-grid__weekday {
    padding: 0.55rem 0.35rem;
    text-align: center;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: $color-brand;
    background: $color-brand-alpha-soft;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}
</style>
